import { StringToBool } from "../utils/StringToBool";
import { QXMLObject } from "./QXMLObject";

export class QFilter extends QXMLObject {
  constructor() {
    super();
    this.fFilterName = null;
    this.fFilterDef = null;
    this.fFilterOff = true;
    this.fHidden = false;
    this.fFilterOnByDefault = false;
    //TODO: This
    this.fFilterEditField = null;
  }

  DoInitFilter() {
    this.SetXMLElementName("filter");
  }

  // AUG26
  InitFilter(filterName, filterDef, filterOff) {
    this.fFilterName = filterName;
    this.fFilterDef = filterDef;
    this.fFilterOff = filterOff;
    this.DoInitFilter();
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("fname", this.fFilterName, stream);
    this.OutputSimpleElement("fdef", this.fFilterDef, stream);
    this.OutputSimpleElement("foff", this.fFilterOff, stream);
    //this.OutputSimpleElement("fhidden", this.fHidden, stream);
  }

  OutputToJSON(stream) {
    var fObj = {};
    fObj["name"] = this.fFilterName;
    fObj["def"] = this.fFilterDef;
    fObj["active"] = !this.fFilterOff;
    return fObj;
  }

  LoadFromJSON(json) {
    this.fFilterName = json["name"];
    this.fFilterDef = json["def"];
    this.fFilterOff = !json["active"];
  }

  LoadSubElements(objTree) {
    this.fFilterName = objTree.GetValueForChild("fname", false);
    this.fFilterDef = objTree.GetValueForChild("fdef", false);
    var filterOff = objTree.GetValueForChild("foff", false);
    //var filterHidden = objTree.GetValueForChild("fhidden",false);
    this.fFilterOff = StringToBool(filterOff);
    //this.fHidden = StringToBool(filterHidden);
  }

  GetFilterApplied() {
    return !this.fFilterOff;
  }

  SetFilterApplied(filterOn) {
    this.fFilterOff = !filterOn;
  }

  GetFilterDef() {
    return this.fFilterDef;
  }

  GetFilterName() {
    return this.fFilterName;
  }

  Clone() {
    var cFilter = new QFilter();
    cFilter.fFilterOff = this.fFilterOff;
    cFilter.fFilterName = this.fFilterName;
    cFilter.fFilterDef = this.fFilterDef;

    return cFilter;
  }
}
